export const RESET_UNDERWRITER = 'underwriter/RESET_UNDERWRITER'
export const SET_UNDERWRITER = 'underwriter/SET_UNDERWRITER'
export const SET_USER = 'underwriter/SET_USER'
export const UNSET_USER = 'underwriter/UNSET_USER'
export const resetUnderWriter = () => ({
    type: RESET_UNDERWRITER
})

export const setUnderWriter = payload => ({
    type: SET_UNDERWRITER,
    payload,
})

export const setLoggedUser = payload => ({
    type: SET_USER,
    payload
})

export const unsetLoggedUser = () => ({
    type: UNSET_USER
})
